// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/announce/announce.mdl.scss
// module id = 978
// module chunks = 0